<template>
  <transition name="reveal-single-line">
    <div
      v-if="commentCount"
      class="single-obituary-comment__threaded-comment-count"
    >
      <button class="btn link" @click.prevent="showComments">
        {{ commentCount }} {{ commentLabel }}
      </button>
    </div>
  </transition>
</template>

<script>
import { useScrollIntoView } from 'Composables/useScrollIntoView';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'ThreadedCommentCount',

  setup() {
    const {
      scrollIntoView,
      scrollIntoViewCentered,
      scrollIntoViewAlignBottom,
    } = useScrollIntoView();
    return {
      scrollIntoView,
      scrollIntoViewCentered,
      scrollIntoViewAlignBottom,
    };
  },

  props: {
    parent: {
      type: Object,
      required: true,
    },
    commentCount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      texts: lavendlaObituary.threadedComments,
    };
  },

  computed: {
    ...mapState('threadedComments', ['showAll']),
    ...mapGetters('global', ['isMobile']),

    commentLabel() {
      return this.commentCount > 1 ? this.texts.comments : this.texts.comment;
    },
  },

  methods: {
    ...mapMutations('threadedComments', ['setParent', 'setShowAll']),
    ...mapActions('threadedComments', ['toggleModal']),

    showComments() {
      if (this.isMobile) {
        !this.showAll.some((id) => id === this.parent.id) &&
          this.setShowAll(this.parent.id);
        this.scrollIntoViewCentered(
          '.single-obituary-comment__threaded-comments',
          `#comment-${this.parent.id}`
        );
        return;
      }

      this.setParent(this.parent);
      this.toggleModal('list');
    },
  },
};
</script>
